import {
  Component,
  Input,
  ViewChild,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { MapsAPILoader } from '@ng-maps/core';

@Component({
  selector: 'app-street-view',
  templateUrl: './app-street-view.component.html',
  styleUrls: ['./app-street-view.component.scss']
})
export class StreetViewComponent implements OnInit, AfterViewInit {
  @Input()
  lat: number;
  @Input()
  lng: number;
  @Input()
  heading: number = 34;
  @Input()
  scrollwheel: boolean = true;
  @Input()
  delayZoomScroll: boolean = true;

  private static MOUSE_ENTER_DELAY = 500;
  private enableZoomTimeout: any;

  streetviewPanorama: google.maps.StreetViewPanorama;

  mapsLoadPromise: Promise<void>;

  @ViewChild('streetviewPano')
  streetviewPano: any;

  constructor(private mapsAPILoader: MapsAPILoader) {}

  ngOnInit() {
    this.mapsLoadPromise = this.mapsAPILoader.load();
  }

  ngAfterViewInit() {
    this.mapsLoadPromise.then(() => {
      this.streetviewPanorama = new google.maps.StreetViewPanorama(
        this.streetviewPano.nativeElement,
        {
          position: { lat: this.lat, lng: this.lng },
          scrollwheel: this.scrollwheel && !this.delayZoomScroll ? true : false
        }
      );
    });
  }

  onMouseEnter() {
    if (this.delayZoomScroll && this.streetviewPanorama != null) {
      this.enableZoomTimeout = setTimeout(
        () => this.streetviewPanorama.setOptions({ scrollwheel: true }),
        StreetViewComponent.MOUSE_ENTER_DELAY
      );
    }
  }

  onMouseLeave() {
    if (this.delayZoomScroll && this.streetviewPanorama != null) {
      clearTimeout(this.enableZoomTimeout);
      this.streetviewPanorama.setOptions({ scrollwheel: false });
    }
  }
}
